"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
var _constants = require("./lib/constants");
class CardsApi extends _basic_data_hub_api.default {
  async deleteCard(_ref) {
    let {
      id
    } = _ref;
    let temporarily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return this._callApi({
      path: `/cards/${id}`,
      method: 'delete',
      queryParams: {},
      payload: {
        temporarily
      }
    });
  }
  async recoverCard(_ref2) {
    let {
      id
    } = _ref2;
    return this._callApi({
      path: `/cards/${id}`,
      method: 'patch',
      queryParams: {}
    });
  }
  async getCardById(id, projection) {
    return this._callApi({
      path: `/cards/${id}`,
      queryParams: {
        projection
      }
    });
  }
  async getCards(_ref3) {
    let {
      query = {},
      projection,
      includeDeleted = false,
      includeExisting = true,
      limit,
      offset,
      group,
      sandbox
    } = _ref3;
    query = _lodash.default.cloneDeep(query);
    if (includeDeleted && !includeExisting) query.isDeleted = true;
    if (includeExisting && !includeDeleted) query.isDeleted = false;
    if (typeof query.id === 'string') query.id = query.id.split(',');

    // explicitly downloaded templates must not have 'reference.id' field
    if (query.explicitly && query.downloaded && query.templates) {
      query['reference.id'] = null;
    }
    if (query.explicitly) {
      delete query.explicitly;
      query['template.implicitly'] = {
        not: true
      };
    }
    if (query.downloaded) {
      delete query.downloaded;
      query['template.type'] = {
        ne: null
      };
      query['template.version'] = {
        ne: null
      };
    }
    if (query.templates) {
      delete query.templates;
      query.template = {
        ne: null
      };
    }
    if (query.custom) {
      delete query.custom;
      query['template.type'] = null;
    }
    if (_lodash.default.isArray(projection) && projection.length === 0) projection = undefined;
    return this._callApi({
      path: '/get-cards',
      method: 'post',
      payload: {
        query,
        projection,
        limit,
        offset,
        group,
        sandbox
      }
    });
  }
  async getCardsByToken(_ref4) {
    let {
      query = {},
      projection,
      limit,
      token
    } = _ref4;
    const binding = await this.getBinding();
    const method = this._getMethodName('list');
    const accountId = this.accountId;
    return binding.query[method]({
      entity: _constants.CARD,
      params: {
        ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
        queryParams: query,
        limit,
        last: token
      },
      ...(accountId ? {
        accountId
      } : {})
    }, projection || ['records', 'last']);
  }
  async replaceCardTemplate(templateId, cardIds) {
    return this._callApi({
      path: `/card-templates/${templateId}`,
      method: 'post',
      queryParams: {},
      payload: {
        cardIds
      }
    });
  }
  async saveCard(card) {
    card = _lodash.default.cloneDeep(card);
    card.id = card.id || 'new';
    const res = await this._callApi({
      path: `/cards/${card.id}`,
      method: 'post',
      queryParams: {},
      payload: {
        card
      }
    });
    return this.setDiff(card, res);
  }
  getNewCard() {
    //eslint-disable-line
    return {
      data: {
        presentation: {
          template: '<div class="card-form">\n  <div class="card-padding">\n    <label class="card-title">{{cardLabel}}</label>\n    <label class="card-title secondary">{{cardDescription}}</label>\n    <div class="card-content">\n    </div>\n  </div>\n</div>\n',
          code: 'return {\n  computed: {\n    cardDescription() {\n      return this.userData.description;\n    },\n\n    cardLabel() {\n      return this.userData.label;\n    },\n\n    formData() {\n      const data = _.get(this.data, \'form.data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    },\n\n    presentationData() {\n      const data = _.get(this.data, \'presentation.data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    },\n\n    userData() {\n      const data = _.get(this.data, \'data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    }\n  },\n\n  created() {\n    //\n  },\n\n  beforeDestroy() {\n    //\n  },\n\n  data() {\n    return {\n      //\n    };\n  },\n\n  methods: {\n    // use this method to refresh layout if the card shows a content with dynamic height e.g. table with N rows\n    raiseRefreshLayout() {\n      if (this.userData.heightOption === \'auto\') {\n        cardMessageBus.$emit(\'card::refresh-layout\', {\n          id: this.data.cardId\n        });\n      }\n    }\n\n    // \n  },\n\n  mounted() {\n    // \n  },\n\n  watch: {\n    //\n  },\n\n  props: {\n    data: {\n      type: Object,\n      required: true\n    },\n\n    editable: {\n      type: Boolean,\n      default: true\n    },\n\n    sharedData: {\n      type: Object,\n      default: null\n    }\n  }\n};\n',
          style: '.card-form {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.card-content {\n  display: flex;\n  flex-grow: 1;\n  display: -webkit-box;\n  -webkit-box-flex: 1;\n  display: -ms-flexbox;\n  -ms-flex-positive: 1;\n}\n\n.card-padding {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding: 26px 19px 19px 19px;\n}\n\n.card-title {\n  font-size: 24px;\n  font-weight: bold;\n\n  &.secondary {\n    font-weight: normal;\n    font-size: 12px;\n  }\n}\n',
          data: null
        },
        form: {
          template: '<div class="form-wrapper">\n  <or-collapsible title="Layout" class="collapsible-card-data" open disable-ripple>\n    <div class="form-row">\n      <div class="form-col">\n        <or-select label="Card height" v-model="heightOption" :options="heightOptions" placeholder="card height"></or-select>\n      </div>\n      <div class="form-col narrow" v-if="heightOption === \'height-custom-px\'">\n        <div class="textbox-right-label">\n          <or-textbox type="number" :min="100" step="10" v-model="heightInput" @change="updateCustomHeight"></or-textbox>\n          <span class="form-row-label">px</span>\n        </div>\n      </div>\n    </div>\n    <div class="form-row">\n      <div class="form-col">\n        <or-select label="Card width" v-model="widthOption" :options="widthOptions" placeholder="card width"></or-select>\n      </div>\n      <div class="form-col narrow" v-if="widthOption === \'width-custom-px\'">\n        <div class="textbox-right-label">\n          <or-textbox type="number" :min="100" step="10" v-model="widthInput" @change="updateCustomWidth"></or-textbox>\n          <span class="form-row-label">px</span>\n        </div>\n      </div>\n    </div>\n  </or-collapsible>\n</div>\n',
          code: 'return {\n  computed: {\n    heightCustom: {\n      get() {\n        return _.replace(this.userData.height, /\\D+[\\s\\S]+/g, \'\');\n      },\n      set(value) {\n        this.setData([{\n          "path": "height",\n          "newSetting": `${value}px`\n        }]);\n      }\n    },\n\n    heightOption: {\n      get() {\n        return this.userData.heightOption;\n      },\n      set(value) {\n        const changes = [{\n          "path": "heightOption",\n          "newSetting": value\n        }];\n        if (value === \'height-custom-px\') {\n          changes.push({\n            "path": "height",\n            "newSetting": `${this.heightInput || this.heightMin}px`\n          });\n        } else if (value !== \'height-full-column\') {\n          changes.push({\n            "path": "height",\n            "newSetting": value\n          });\n          if (value !== \'auto\') {\n            this.heightInput = value.replace(/\\D+[\\s\\S]+/g, \'\');\n          }\n        }\n        const viewClasses = _.difference(this.userData.viewClasses, [\'height-full-column\']);\n        if (value === \'height-full-column\') {\n          viewClasses.push(\'height-full-column\');\n        }\n        if (!_.isEqual(this.userData.viewClasses, viewClasses)) {\n          changes.push({\n            "path": "viewClasses",\n            "newSetting": _.cloneDeep(viewClasses)\n          });\n        }\n        this.setData(changes);\n      }\n    },\n\n    heightOptions() {\n      return _.get(this.formData, \'heightOptions\') || [];\n    },\n\n    userData() {\n      return _.cloneDeep(this.value) || {};\n    },\n\n    widthCustom: {\n      get() {\n        return _.replace(this.userData.width, /\\D+[\\s\\S]+/g, \'\');\n      },\n      set(value) {\n        this.setData([{\n          "path": "width",\n          "newSetting": `${value}px`\n        }]);\n      }\n    },\n\n    widthOption: {\n      get() {\n        return this.userData.widthOption;\n      },\n      set(value) {\n        this.setData([{\n          "path": "widthOption",\n          "newSetting": value\n        }, {\n          "path": "viewClasses",\n          "newSetting": this.refreshWidthClass(value)\n        }]);\n      }\n    },\n\n    widthOptions() {\n      return _.get(this.formData, \'widthOptions\') || [];\n    },\n\n    widthOptionValues() {\n      return _.map(this.widthOptions, \'value\');\n    }\n  },\n\n  data() {\n    return {\n      heightInput: 100,\n      widthInput: 100\n    }\n  },\n\n  methods: {\n    refreshWidthClass(widthClass) {\n      const viewClasses = _.difference(this.userData.viewClasses, this.widthOptionValues);\n      return widthClass === \'width-custom-px\' ? viewClasses : _.concat(viewClasses, [widthClass]);\n    },\n\n    setData(changes, reloadCardDetails = true) {\n      try {\n        const beforeChange = _.cloneDeep(this.value);\n        const afterChange = _.cloneDeep(this.value);\n\n        _.forEach(changes, item => {\n          const path = _.get(item, \'path\');\n          if (path && _.has(item, \'newSetting\')) {\n            const newValue = _.get(item, \'newSetting\');\n            const oldValue = _.get(beforeChange, path);\n            if (!_.isEqual(newValue, oldValue)) {\n              _.set(afterChange, path, newValue);\n            }\n          }\n        });\n\n        if (!_.isEqual(afterChange, beforeChange)) {\n          this.$emit(reloadCardDetails === true ? \'input\' : \'apply-new-settings\', afterChange);\n        }\n      } catch (e) {\n        console.log(e);\n      }\n    },\n\n    updateCustomHeight(value) {\n      this.heightInput = Math.max(value, 100);\n      this.heightCustom = this.heightInput;\n\n    },\n\n    updateCustomWidth(value) {\n      this.widthInput = Math.max(value, 100);\n      this.widthCustom = this.widthInput;\n    }\n  },\n\n  mounted() {\n    this.heightInput = this.heightCustom;\n    this.widthInput = this.widthCustom;\n  },\n\n  props: {\n    formData: {\n      type: Object,\n      default: null\n    },\n\n    sharedData: {\n      type: Object,\n      default: null\n    },\n\n    value: {\n      type: Object,\n      required: true\n    }\n  }\n};\n',
          style: '.form-wrapper {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  -webkit-justify-content: space-around;\n  justify-content: space-around;\n}\n\n.form-row-with-label {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n\n.form-row-label {\n  font-size: 12px;\n  color: #91969d;\n  line-height: 36px;}\n\n.form-row {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n}\n\n.form-row-margin-bottom {\n  margin-bottom: 20px;\n}\n\n.form-col {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding-right: 10px;\n  \n  &.narrow {\n    flex-grow: 0;\n  }\n}\n\n.textbox-right-label {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  margin-top: 36px;\n  \n  .ui-textbox {\n    margin-bottom: 0;\n    margin-right: 10px;\n    width: 90px;\n  }\n}\n',
          data: {
            customForm: true,
            heightOptions: [{
              label: 'Auto',
              value: 'auto'
            }, {
              label: 'Short',
              value: '250px'
            }, {
              label: 'Medium',
              value: '350px'
            }, {
              label: 'Tall',
              value: '700px'
            }, {
              label: 'Full column',
              value: 'height-full-column'
            }, {
              label: 'Custom',
              value: 'height-custom-px'
            }],
            widthOptions: [{
              label: 'Narrow',
              value: 'width-narrow'
            }, {
              label: 'Medium',
              value: 'width-medium'
            }, {
              label: 'Wide',
              value: 'width-wide'
            }, {
              label: 'Full row',
              value: 'width-full-row'
            }, {
              label: 'Custom',
              value: 'width-custom-px'
            }]
          }
        },
        data: {
          description: 'I\'m going to build my own card',
          height: '350px',
          heightOption: '350px',
          label: 'My custom card',
          viewClasses: ['card-no-padding', 'width-medium'],
          width: '300px',
          widthOption: 'width-medium'
        }
      }
    };
  }
}
var _default = CardsApi;
exports.default = _default;